import { cn } from "@/utils/cn";

/**
 * 긴급대체 모달 — 「대체 근무자 찾기」그라데이션 버튼 (당일/기간 지정 동일 스타일)
 */
export default function EmergencyReplacementFindButton({
  isPending,
  showGradientStyle,
  disabled,
  onClick,
  title,
  className,
}: {
  isPending: boolean;
  /** false일 때 회색 비활성(슬롯 없음 등). true일 때 그라데이션 */
  showGradientStyle: boolean;
  disabled?: boolean;
  onClick?: () => void;
  title?: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      title={title}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        "flex min-h-[70px] flex-1 items-center justify-center gap-2.5 rounded-xl border-0 px-5 py-3 font-pretendard text-white transition-opacity",
        showGradientStyle
          ? cn(
              !isPending &&
                "bg-gradient-to-r from-[#07ACE3] via-[#0D5DF7] to-[#FE0E82]",
              isPending
                ? "cursor-not-allowed"
                : disabled
                  ? "cursor-not-allowed opacity-90"
                  : "cursor-pointer hover:opacity-95"
            )
          : "cursor-not-allowed bg-zinc-200 opacity-90",
        className
      )}
      style={
        isPending
          ? {
              backgroundImage:
                "linear-gradient(90deg, #07ACE3 0%, #0D5DF7 50%, #FE0E82 100%)",
              backgroundSize: "220% 100%",
              backgroundPosition: "0% 50%",
              animation: "emergency-gradient-roll 1.4s linear infinite",
              willChange: "background-position",
            }
          : undefined
      }
    >
      {isPending ? (
        <div className="flex items-center gap-0">
          <img
            src="/asset/logo/btn_logo.png"
            alt=""
            aria-hidden
            className="shrink-0"
          />
          <span className="text-[15px] font-semibold text-white">
            가 찾는중..
          </span>
        </div>
      ) : (
        <>
          <img
            src="/asset/icon/config/emergency.svg"
            alt=""
            aria-hidden
            className="size-6 shrink-0 brightness-0 invert"
          />
          <span className="text-[15px] font-semibold text-white">
            대체 근무자 찾기
          </span>
        </>
      )}
    </button>
  );
}
